if (!window.customElements.get("component-bulky-item")) {

    class ProductsSlider extends HTMLElement {

        constructor() {
            super();

            this.selectors = {
                content: ".bulky-item__info-popup",
                close: ".bulky-item__close"
            }

            this._isOpened = false;
        }


        connectedCallback() {
           this.defineElements();
           this.addListeners();
        }

        defineElements() {
            this.closeButton = this.querySelector(this.selectors.close);
            this.contentModal = this.querySelector(this.selectors.content);
        }

        addListeners() {

            if (this.closeButton) {
            this.closeButton.addEventListener('click', this.close.bind(this));
            }

            this.customDelegate(
                "click",
                '.bulky-item__info-opener',
                this.fieldClickHandler.bind(this)
            )
        }

        toggleAttribute(show) {
            show = (show !== undefined) ? show : !this._isOpened;
            this._isOpened = show;
            this._isOpened ? this.modalStateOpen() : this.modalStateClose();
        };

        fieldClickHandler() {
            this._isOpened ? this.close() : this.open();
        };

        close() {
            this.toggleAttribute(false);
        };

        open() {
            this.toggleAttribute(true);
        }

        modalStateOpen() {
            this.contentModal.setAttribute('open','');
            document.body.classList.add('overflow--hidden');
            this.cloneToProductComponent();
        }

        modalStateClose() {
            this.contentModal.removeAttribute('open');
            document.body.classList.remove('overflow--hidden');
            this.removeCloneFromProductComponent();
        }

        cloneToProductComponent() {
            const mainWrapper = this.closest('product-main');

            if (!mainWrapper) {
                return null
            }

            mainWrapper.appendChild(this.contentModal);
        }

        removeCloneFromProductComponent() {
            const mainWrapper = this.closest('product-main');

            if (!mainWrapper) {
                return null
            }

            mainWrapper.removeChild(this.contentModal);
        }

        customDelegate(eventName, elementSelector, handler) {
            this.addEventListener(eventName, (e) => {
                const element = e.target.closest(elementSelector);

                if (element) {
                    handler.call(element, e, element);
                }
            }, false);
        };

    }

    window.customElements.define("component-bulky-item", ProductsSlider);
}

